// extracted by mini-css-extract-plugin
var _1 = "Colors__blueColor--Ij78j";
var _2 = "Colors__blueColorHoverEffect--tjXHo";
var _3 = "Colors__calloutDarkColor--bxob1";
var _4 = "Colors__calloutLightColor--rD1xB";
var _5 = "Colors__cyanColor--B5XU3";
var _6 = "Colors__cyanColorHoverEffect--UrE7f";
var _7 = "Colors__demoColor--mUCJh";
var _8 = "Colors__demoYellowColor--Oee8N";
var _9 = "Colors__grade-1Color--Kz8le";
var _a = "Colors__grade-1ColorHoverEffect--Uqhrx";
var _b = "Colors__grade-2Color--_2wYG";
var _c = "Colors__grade-2ColorHoverEffect--WgQHT";
var _d = "Colors__grade-3Color--fN2JV";
var _e = "Colors__grade-3ColorHoverEffect--ChIrd";
var _f = "Colors__grade-4Color--QbjlL";
var _10 = "Colors__grade-4ColorHoverEffect--ec6sO";
var _11 = "Colors__grade-5Color--hRuJo";
var _12 = "Colors__grade-5ColorHoverEffect--h4Yv0";
var _13 = "Colors__grayColor--xNqpl";
var _14 = "Colors__grayColorHoverEffect--d09Mq";
var _15 = "Colors__greenColor--T8neD";
var _16 = "Colors__greenColorHoverEffect--QIp6B";
var _17 = "Colors__greenHoverColor--qKkKt";
var _18 = "Colors__iconYellowColor--zvxs4";
var _19 = "Colors__iconYellowColorHoverEffect--xFl3t";
var _1a = "Colors__linkColor--yro_E";
var _1b = "Colors__mainBlueColor--Esafz";
var _1c = "Colors__mainBlueColorHoverEffect--GP0Kd";
var _1d = "Colors__mediumLightGrayColor--h6hJx";
var _1e = "Colors__mediumLightGrayColorHoverEffect--P4bse";
var _1f = "Colors__redColor--p9cLG";
var _20 = "Colors__redColorHoverEffect--Bi_uO";
var _21 = "Colors__redHoverColor--LY6hS";
var _22 = "Colors__transparentBlackColor--gWEn3";
var _23 = "Colors__transparentBlackColorHoverEffect--aJ5ns";
var _24 = "Colors__transparentWhiteColor--cgre5";
var _25 = "Colors__transparentWhiteColorHoverEffect--TDhNf";
var _26 = "Colors__whiteColor--T_ATc";
var _27 = "Colors__whiteColorHoverEffect--lZ1d9";
var _28 = "Colors__yellowColor--SLwYG";
var _29 = "Colors__yellowColorHoverEffect--wvTyn";
export { _1 as "blueColor", _2 as "blueColorHoverEffect", _3 as "calloutDarkColor", _4 as "calloutLightColor", _5 as "cyanColor", _6 as "cyanColorHoverEffect", _7 as "demoColor", _8 as "demoYellowColor", _9 as "grade-1Color", _a as "grade-1ColorHoverEffect", _b as "grade-2Color", _c as "grade-2ColorHoverEffect", _d as "grade-3Color", _e as "grade-3ColorHoverEffect", _f as "grade-4Color", _10 as "grade-4ColorHoverEffect", _11 as "grade-5Color", _12 as "grade-5ColorHoverEffect", _13 as "grayColor", _14 as "grayColorHoverEffect", _15 as "greenColor", _16 as "greenColorHoverEffect", _17 as "greenHoverColor", _18 as "iconYellowColor", _19 as "iconYellowColorHoverEffect", _1a as "linkColor", _1b as "mainBlueColor", _1c as "mainBlueColorHoverEffect", _1d as "mediumLightGrayColor", _1e as "mediumLightGrayColorHoverEffect", _1f as "redColor", _20 as "redColorHoverEffect", _21 as "redHoverColor", _22 as "transparentBlackColor", _23 as "transparentBlackColorHoverEffect", _24 as "transparentWhiteColor", _25 as "transparentWhiteColorHoverEffect", _26 as "whiteColor", _27 as "whiteColorHoverEffect", _28 as "yellowColor", _29 as "yellowColorHoverEffect" }
